<div class="offcanvas-header">
	<div class="heading">
		<h3 class="offcanvas-title">Manage Stock</h3>
		<div class="subheading">{{ inventoryItem.sku }} ({{ inventoryItem.name }})</div>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
		<ng-template #loadedContent>
			<div class="inventory-item-location-container">
				<div class="section">
					<h6>Stock by Location</h6>

					<ng-container *ngIf="inventoryItemLocations.length > 0; else noLocations">
						<div class="table-container">
							<div class="table-headings">
								<div class="column-name long">Name</div>
								<div class="column-name long">Quantity</div>
								<div class="column-name action"></div>
							</div>

							<ng-container *ngFor="let itemLocation of inventoryItemLocations">
								<div class="table-row">
									<div class="inner-row long">
										{{ itemLocation.locationData?.name | nullDefault: '-' }}
									</div>
									<div class="inner-row long">
										{{ itemLocation.quantity | nullDefault: '-' }}
									</div>
									<div class="inner-row action">
										<button role="button" class="btn btn-sm" (click)="adjustStockQuantity(itemLocation)">
											<i class="bi bi-pencil-square"></i>
										</button>
									</div>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<ng-template #noLocations>
						<div class="text-muted fst-italic">No stock at any location yet.</div>
					</ng-template>
				</div>

				<div class="section">
					<h6>Add to Location</h6>

					<app-alert
						*ngIf="hasPendingAdjustments"
						[alertType]="AlertTypes.WARNING"
						content="There are pending stock adjustments for this item. Please wait for them to complete before adding more stock."
					></app-alert>

					<ng-container *ngIf="inventoryLocationOptions.length > 0; else noAvailableLocations">
						<div class="form-container">
							<app-dropdown-control
								name="location"
								[formGroup]="form"
								label="Location"
								placeholder="Select Location"
								[options]="inventoryLocationOptions"
							></app-dropdown-control>

							<app-standard-control
								type="number"
								name="quantity"
								[formGroup]="form"
								label="Quantity"
								placeholder="Quantity"
							></app-standard-control>
						</div>

						<button
							type="button"
							class="btn btn-sm btn-primary"
							(click)="addToLocation()"
							[disabled]="form.invalid || form.pristine || isAddingToLocation"
						>
							<ng-container *ngIf="isAddingToLocation; else notLoading">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</ng-container>
							<ng-template #notLoading> <i class="bi bi-plus"> </i> Add Stock to Location</ng-template>
						</button>
					</ng-container>

					<ng-template #noAvailableLocations>
						<div class="text-muted fst-italic">This item is stocked at all available locations.</div>
					</ng-template>
				</div>

				<div class="section">
					<h6>Stock Adjustments</h6>
					<div class="text-muted fst-italic">View the history of stock adjustments for this item.</div>

					<ng-container *ngIf="inventoryStockAdjustments.length > 0; else noStockAdjustments">
						<div class="table-container">
							<div class="table-headings">
								<div class="column-name short">Status</div>
								<div class="column-name long">Date</div>
								<div class="column-name long">Location</div>
								<div class="column-name short">Change</div>
								<div class="column-name long">Reason</div>
							</div>

							<ng-container *ngFor="let stockAdjustment of inventoryStockAdjustments">
								<div class="table-row">
									<div class="inner-row short">
										<i
											class="bi fs-4"
											[class.bi-arrow-repeat]="stockAdjustment.status === 'pending'"
											[class.icon-spin]="stockAdjustment.status === 'pending'"
											[class.text-info]="stockAdjustment.status === 'pending'"
											[class.bi-patch-check]="stockAdjustment.status === 'success'"
											[class.text-success]="stockAdjustment.status === 'success'"
											[class.bi-patch-exclamation]="stockAdjustment.status === 'failed'"
											[class.text-danger]="stockAdjustment.status === 'failed'"
										></i>
									</div>
									<div class="inner-row long">
										{{ stockAdjustment.createdDate.toDate() | date: 'yyyy-MM-dd' }}
									</div>
									<div class="inner-row long">
										{{ stockAdjustment.locationData?.name | nullDefault: '-' }}
									</div>
									<div class="inner-row short">
										<span
											class="badge"
											[class.text-bg-success]="stockAdjustment.changeType === 'increase'"
											[class.text-bg-danger]="stockAdjustment.changeType === 'decrease'"
										>
											<i
												class="bi"
												[class.bi-arrow-up]="stockAdjustment.changeType === 'increase'"
												[class.bi-arrow-down]="stockAdjustment.changeType === 'decrease'"
											></i>
											{{ stockAdjustment.quantity | nullDefault: '-' }}
										</span>
									</div>
									<div class="inner-row long">
										{{ stockAdjustment.reason | nullDefault: '-' }}
									</div>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<ng-template #noStockAdjustments>
						<div class="text-muted fst-italic">No stock adjustments for this item yet.</div>
					</ng-template>
				</div>
			</div>
		</ng-template>
	</div>
</div>
